export const BORDER_BOTTOM_VALUE = 1;
